import "./Header.css";
import Navbar from "../Navbar/Navbar";

const Header = () => {
  return (
    <header className="flex j-c--center header">
      <Navbar />
    </header>
  );
};
export default Header;
